(function () {
	const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

	const revealOnLoad = (root) => {
		if (REDUCED_MOTION.matches) {
			root.classList.add('is-in-view');
			return;
		}

		const start = () => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					root.classList.add('is-in-view');
				});
			});
		};

		if (document.fonts?.ready) {
			document.fonts.ready.then(start).catch(start);
		} else {
			start();
		}
	};

	const revealSection = (root) => {
		if (root.dataset.inViewReady === 'true') return;
		root.dataset.inViewReady = 'true';

		const children = root.querySelectorAll('[data-in-view-child]');
		if (!children.length) return;

		if (REDUCED_MOTION.matches) {
			root.classList.add('is-in-view');
			return;
		}

		if (root.hasAttribute('data-in-view-on-load')) {
			revealOnLoad(root);
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-in-view');
					observer.unobserve(entry.target);
				});
			},
			{ threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
		);

		observer.observe(root);
	};

	const initSectionInView = () => {
		document.querySelectorAll('[data-in-view]').forEach(revealSection);
	};

	document.addEventListener('DOMContentLoaded', initSectionInView);
	document.addEventListener('shopify:section:load', initSectionInView);
})();
